import { FC } from 'react'
import styles from './RecommendedCoinLockerCardList.module.scss'
import { useTranslation } from 'next-i18next'

//type
import { Space } from 'state/ducks/space/models.new'
import type { LegacyCoinLocker } from 'features/coin-locker/types/legacyCoinLocker'

//component
import { CoinLockerCard } from 'components/cards/CoinLockerCard'
import RecommendedCoinLockerCardOldComponent from 'components/cards/RecommendedCoinLockerCardOld'
import { AdBanner } from 'components/ads/AdBanner'
import { NHK_AREA_PAGE_BANNER_CONFIG } from 'constants/ads'

interface Props {
  lockers: Space[]
  oldList: LegacyCoinLocker[]
  locale: string
}

const RecommendedCoinLockerCardList: FC<Props> = ({
  lockers,
  oldList,
  locale,
}: Props): JSX.Element => {
  const { t } = useTranslation()

  const showAdLocale = locale === 'en' || locale === 'zh_tw'
  const hasLockers = lockers.length > 0 || oldList.length > 0

  return (
    <>
      {hasLockers ? (
        <div>
          {/* ECBO_API_URL/api/web/lockers — order first in combined list */}
          {lockers.length > 0 && (
            <div className={`${styles.container} ${oldList.length > 0 ? styles.listWithGap : ''}`}>
              {lockers.map((locker, index) => {
                const showAdAfterSecondNew = lockers.length >= 2 && index === 1
                const showAdEndOnlyNewList =
                  lockers.length === 1 && oldList.length === 0 && index === 0
                return (
                  <div key={locker.space_id}>
                    <CoinLockerCard locker={locker} />
                    {showAdLocale && (showAdAfterSecondNew || showAdEndOnlyNewList) && (
                      <AdBanner {...NHK_AREA_PAGE_BANNER_CONFIG} />
                    )}
                  </div>
                )
              })}
            </div>
          )}

          {/* ECBO_API_URL/api/web/coin_lockers — follows new lockers in combined order */}
          {oldList.length > 0 && (
            <ul className={styles.list}>
              {oldList.map((recommended: LegacyCoinLocker, index) => {
                const showAdAfterSecondOldOnly =
                  lockers.length === 0 && oldList.length >= 2 && index === 1
                const showAdAfterSecondGlobalInOld =
                  lockers.length === 1 && oldList.length >= 1 && index === 0
                const showAdEndOnlyOldList =
                  lockers.length === 0 && oldList.length === 1 && index === 0

                return (
                  <li
                    id={`recommended-coin-locker-card-old-${recommended.id}`}
                    className={styles.listItem}
                    key={`old-${recommended.id}-${index}`}
                  >
                    <RecommendedCoinLockerCardOldComponent
                      coinLocker={recommended}
                      locale={locale}
                    />
                    {showAdLocale &&
                      (showAdAfterSecondOldOnly ||
                        showAdAfterSecondGlobalInOld ||
                        showAdEndOnlyOldList) && <AdBanner {...NHK_AREA_PAGE_BANNER_CONFIG} />}
                  </li>
                )
              })}
            </ul>
          )}
        </div>
      ) : (
        <p className={styles.noDataText}>{t('AREAS.CITY.SLUG.NO_COIN_LOCKER_DATA')}</p>
      )}
    </>
  )
}

export default RecommendedCoinLockerCardList
